import React from "react";

import { IProps } from "./sidebar-header.types";

/**
 * A header that will appear at the top of the sidebar.
 * @param props.children The contents of the header.
 */
const SidebarHeader = ({ children }: IProps) => <div className="sidebar__header">{children}</div>;

export default SidebarHeader;
